import React from 'react';

import { Avatar } from '@mui/material';
import { useRouter } from 'next/router';

const TokenLockedPopup = ({ file, setShowAudience }: any) => {
  const router = useRouter();
  return (
    <div className="p-2">
      <div>
        <p className="flex justify-items-start ">Network</p>
        <div className="border mt-2 cursor-pointer rounded-lg border-black w-full p-3">
          <p className="flex justify-items-start ">{`${file.data.token.chain[0].toUpperCase()}${file.data.token.chain.substring(
            1
          )}`}</p>
        </div>
      </div>
      <div className="mt-4">
        <p className="flex justify-items-start">Token</p>
        <div className="border cursor-pointer mt-2 rounded-lg border-black w-full flex p-3">
          <Avatar src={file.data.token.image} sx={{ width: 24, height: 24 }} />
          <p className="ml-4 flex justify-center items-center">
            {file.data.token.name}
          </p>
        </div>
      </div>
      <div>
        <p className="flex justify-items-start mt-4">Amount</p>
        <div className="border mt-2 cursor-pointer rounded-lg border-black w-full p-3">
          <p className="flex justify-items-start ">
            {file.data.token.gateBalance}
          </p>
        </div>
      </div>
      <div className=" mt-8 flex items-center">
        <button
          onClick={() => {
            setShowAudience(false);
          }}
          className={`bg-gray-200 font-semibold  py-2 px-8 border rounded-lg`}
        >
          Cancel
        </button>
        <div className="flex w-full justify-end">
          <button
            onClick={() =>
              router.push(`/files/${file.data.uuid}?setAccess=true`)
            }
            className={` bg-yellow font-semibold   py-2 px-8 border rounded-lg`}
          >
            Edit Access
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenLockedPopup;
